











































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import DetailsTable from '@/components/reports/DetailsTable.vue';
import StackedColumnGraph from '@/components/reports/StackedColumnGraph.vue';
import { SingleRecordDetailsInterface } from '@/interfaces/SingleRecordDetailsInterface';
import { ChartDataInterface } from '@/interfaces/ChartDataInterface';
import TrademarkFinite from '@/components/reports/TrademarkFinite.vue';
import TrademarkIndefinite from '@/components/reports/TrademarkIndefinite.vue';
import TrademarkReportedRate from '@/components/reports/TrademarkReportedRate.vue';
import { formatDateWithMonthName } from '@/helpers/dateFormatter';
import { TransformationType } from '@/enums/TransformationType';
import { Action } from 'vuex-class';
import { ProductGroupTypes } from '@/enums/ProductGroupTypes';
import CustomerRelationDetails from '@/components/reports/CustomerRelationDetails.vue';
import TrademarkDetails from '@/components/reports/TrademarkDetails.vue';
import GoodwillDetails from '@/components/reports/GoodwillDetails.vue';
import TechnologyDetails from '@/components/reports/TechnologyDetails.vue';
import TrademarkValuationMultiples from '@/components/reports/TrademarkValuationMultiples.vue';
import CustomerValuationMultiples from '@/components/reports/CustomerValuationMultiples.vue';
import GoodwillValuationMultiples from '@/components/reports/GoodwillValuationMultiples.vue';
import TrademarkFootnotes from '@/components/reports/TrademarkFootnotes.vue';
import CustomerFootnotes from '@/components/reports/CustomerFootnotes.vue';
import GoodwillFootnotes from '@/components/reports/GoodwillFootnotes.vue';
import TechnologyFootnotes from '@/components/reports/TechnologyFootnotes.vue';
import TechnologyValuationMultiples from '@/components/reports/TechnologyValuationMultiples.vue';
import TechnologyFinite from '@/components/reports/TechnologyFinite.vue';
import TechnologyIndefinite from '@/components/reports/TechnologyIndefinite.vue';
import SoftwareDetails from '@/components/reports/SoftwareDetails.vue';
import SoftwareValuationMultiples from '@/components/reports/SoftwareValuationMultiples.vue';
import SoftwareFinite from '@/components/reports/SoftwareFinite.vue';
import SoftwareIndefinite from '@/components/reports/SoftwareIndefinite.vue';
import SoftwareFootnotes from '@/components/reports/SoftwareFootnotes.vue';

// todo - implement dynamic colors when iterating through fields
@Component({
    name: 'SingleRecordDetails',
    components: {
        CustomerFootnotes,
        TrademarkFootnotes,
        CustomerValuationMultiples,
        TrademarkValuationMultiples,
        GoodwillDetails,
        TechnologyDetails,
        TrademarkDetails,
        CustomerRelationDetails,
        DetailsTable,
        StackedColumnGraph,
        TrademarkFinite,
        TrademarkIndefinite,
        TrademarkReportedRate,
        GoodwillValuationMultiples,
        GoodwillFootnotes,
        TechnologyFootnotes,
        TechnologyValuationMultiples,
        TechnologyFinite,
        TechnologyIndefinite,
        SoftwareDetails,
        SoftwareValuationMultiples,
        SoftwareFinite,
        SoftwareIndefinite,
        SoftwareFootnotes,
    },
})
export default class SingleRecordDetails extends Vue {
    @Action('projects/downloadBrand') public downloadBrand!: ({
        id,
        projectName,
    }: {
        id: number;
        projectName: string;
    }) => Promise<string>;

    @Prop({
        default: null,
    })
    protected sampleRecord!: null | SingleRecordDetailsInterface;

    @Prop({
        default: null,
    })
    protected sampleProductGroup!: ProductGroupTypes;

    protected get singleRecordData() {
        if (this.sampleRecord) {
            return this.sampleRecord;
        }
        return this.$store.getters[
            'projects/activeSingleReport'
        ] as SingleRecordDetailsInterface;
    }

    protected chartColors = [
        '#44355b',
        '#664068',
        '#894b70',
        '#a95872',
        '#c66871',
        '#de7d6d',
        '#ee9669',
        '#f7b267',
        '#732673',
    ];
    protected isButtonEnabled = true;

    protected get isTrademark() {
        if (this.sampleProductGroup) {
            return this.sampleProductGroup === ProductGroupTypes.Trademark;
        }
        return (
            this.$store.getters['user/activeProductGroup'] ===
            ProductGroupTypes.Trademark
        );
    }

    protected get isCustomer() {
        if (this.sampleProductGroup) {
            return (
                this.sampleProductGroup === ProductGroupTypes.CustomerRelations
            );
        }
        return (
            this.$store.getters['user/activeProductGroup'] ===
            ProductGroupTypes.CustomerRelations
        );
    }

    protected get isGoodwill() {
        if (this.sampleProductGroup) {
            return this.sampleProductGroup === ProductGroupTypes.Goodwill;
        }
        return (
            this.$store.getters['user/activeProductGroup'] ===
            ProductGroupTypes.Goodwill
        );
    }

    protected get isTechnology() {
        if (this.sampleProductGroup) {
            return this.sampleProductGroup === ProductGroupTypes.Technology;
        }
        return (
            this.$store.getters['user/activeProductGroup'] ===
            ProductGroupTypes.Technology
        );
    }

    protected get isSoftware() {
        if (this.sampleProductGroup) {
            return this.sampleProductGroup === ProductGroupTypes.Software;
        }
        return (
            this.$store.getters['user/activeProductGroup'] ===
            ProductGroupTypes.Software
        );
    }

    protected get trademarkRelationData() {
        return [
            {
                relationTrademark: `Trademark/Brand (${
                    this.singleRecordData.brand.usefulLifetime
                        ? this.singleRecordData.brand.usefulLifetime + ' years'
                        : 'indefinite'
                })`,
                enterpriseValue: this.shouldShowValue(
                    this.singleRecordData.brand.trademarkPerEV,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.trademarkPerEV,
                          TransformationType.Percent,
                      )
                    : '0.0%',
                totalAssets: this.shouldShowValue(
                    this.singleRecordData.brand.trademarkPerTotalAssets,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.trademarkPerTotalAssets,
                          TransformationType.Percent,
                      )
                    : '0.0%',
            },
            {
                relationTrademark: 'Customer relations',
                enterpriseValue: this.shouldShowValue(
                    this.singleRecordData.brand.customerRelationPerEV,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.customerRelationPerEV,
                          TransformationType.Percent,
                      )
                    : '0.0%',
                totalAssets: this.shouldShowValue(
                    this.singleRecordData.brand.customerRelationPerTotalAssets,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand
                              .customerRelationPerTotalAssets,
                          TransformationType.Percent,
                      )
                    : '0.0%',
            },
            {
                relationTrademark: 'Other intangible assets',
                enterpriseValue: this.shouldShowValue(
                    this.singleRecordData.brand.otherIntangiblesPerEV,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.otherIntangiblesPerEV,
                          TransformationType.Percent,
                      )
                    : '0.0%',
                totalAssets: this.shouldShowValue(
                    this.singleRecordData.brand.otherIntangiblesPerTotalAssets,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand
                              .otherIntangiblesPerTotalAssets,
                          TransformationType.Percent,
                      )
                    : '0.0%',
            },
            {
                relationTrademark: 'Goodwill',
                enterpriseValue: this.shouldShowValue(
                    this.singleRecordData.brand.goodwillPerEV,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.goodwillPerEV,
                          TransformationType.Percent,
                      )
                    : '0.0%',
                totalAssets: this.shouldShowValue(
                    this.singleRecordData.brand.goodwillPerTotalAssets,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.goodwillPerTotalAssets,
                          TransformationType.Percent,
                      )
                    : '0.0%',
            },
            {
                relationTrademark: 'Tangible assets',
                enterpriseValue: this.shouldShowValue(
                    this.singleRecordData.brand.tangiblesPerEV,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.tangiblesPerEV,
                          TransformationType.Percent,
                      )
                    : '0.0%',
                totalAssets: this.shouldShowValue(
                    this.singleRecordData.brand.tangiblesPerTotalAssets,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.tangiblesPerTotalAssets,
                          TransformationType.Percent,
                      )
                    : '0.0%',
            },
            {
                relationTrademark: 'total',
                enterpriseValue: this.shouldShowValue(
                    this.singleRecordData.brand.sum,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.sum,
                          TransformationType.Percent,
                      )
                    : '0.0%',
                totalAssets: this.normalizeData(1, TransformationType.Percent),
            },
        ];
    }

    protected get customerRelationData() {
        return [
            {
                relationTrademark: `Customer relations (${
                    this.singleRecordData.brand.lifetimeCv
                        ? this.singleRecordData.brand.lifetimeCv + ' years'
                        : 'indefinite'
                })`,
                enterpriseValue: this.shouldShowValue(
                    this.singleRecordData.brand.customerRelationPerEV,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.customerRelationPerEV,
                          TransformationType.Percent,
                      )
                    : '0.0%',
                totalAssets: this.shouldShowValue(
                    this.singleRecordData.brand.customerRelationPerTotalAssets,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand
                              .customerRelationPerTotalAssets,
                          TransformationType.Percent,
                      )
                    : '0.0%',
            },
            {
                relationTrademark: `Trademark/Brand`,
                enterpriseValue: this.shouldShowValue(
                    this.singleRecordData.brand.trademarkPerEV,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.trademarkPerEV,
                          TransformationType.Percent,
                      )
                    : '0.0%',
                totalAssets: this.shouldShowValue(
                    this.singleRecordData.brand.trademarkPerTotalAssets,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.trademarkPerTotalAssets,
                          TransformationType.Percent,
                      )
                    : '0.0%',
            },
            {
                relationTrademark: 'Other intangible assets',
                enterpriseValue: this.shouldShowValue(
                    this.singleRecordData.brand.otherIntangiblesPerEV,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.otherIntangiblesPerEV,
                          TransformationType.Percent,
                      )
                    : '0.0%',
                totalAssets: this.shouldShowValue(
                    this.singleRecordData.brand.otherIntangiblesPerTotalAssets,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand
                              .otherIntangiblesPerTotalAssets,
                          TransformationType.Percent,
                      )
                    : '0.0%',
            },
            {
                relationTrademark: 'Goodwill',
                enterpriseValue: this.shouldShowValue(
                    this.singleRecordData.brand.goodwillPerEV,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.goodwillPerEV,
                          TransformationType.Percent,
                      )
                    : '0.0%',
                totalAssets: this.shouldShowValue(
                    this.singleRecordData.brand.goodwillPerTotalAssets,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.goodwillPerTotalAssets,
                          TransformationType.Percent,
                      )
                    : '0.0%',
            },
            {
                relationTrademark: 'Tangible assets',
                enterpriseValue: this.shouldShowValue(
                    this.singleRecordData.brand.tangiblesPerEV,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.tangiblesPerEV,
                          TransformationType.Percent,
                      )
                    : '0.0%',
                totalAssets: this.shouldShowValue(
                    this.singleRecordData.brand.tangiblesPerTotalAssets,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.tangiblesPerTotalAssets,
                          TransformationType.Percent,
                      )
                    : '0.0%',
            },
            {
                relationTrademark: 'total',
                enterpriseValue: this.shouldShowValue(
                    this.singleRecordData.brand.sum,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.sum,
                          TransformationType.Percent,
                      )
                    : '0.0%',
                totalAssets: this.normalizeData(1, TransformationType.Percent),
            },
        ];
    }

    protected get goodwillRelationData() {
        return [
            {
                relationTrademark: 'Goodwill',
                enterpriseValue: this.shouldShowValue(
                    this.singleRecordData.brand.goodwillPerEV,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.goodwillPerEV,
                          TransformationType.Percent,
                      )
                    : '0.0%',
                totalAssets: this.shouldShowValue(
                    this.singleRecordData.brand.goodwillPerTotalAssets,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.goodwillPerTotalAssets,
                          TransformationType.Percent,
                      )
                    : '0.0%',
            },
            {
                relationTrademark: 'Customer relations',
                enterpriseValue: this.shouldShowValue(
                    this.singleRecordData.brand.customerRelationPerEV,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.customerRelationPerEV,
                          TransformationType.Percent,
                      )
                    : '0.0%',
                totalAssets: this.shouldShowValue(
                    this.singleRecordData.brand.customerRelationPerTotalAssets,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand
                              .customerRelationPerTotalAssets,
                          TransformationType.Percent,
                      )
                    : '0.0%',
            },
            {
                relationTrademark: `Trademark/Brand`,
                enterpriseValue: this.shouldShowValue(
                    this.singleRecordData.brand.trademarkPerEV,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.trademarkPerEV,
                          TransformationType.Percent,
                      )
                    : '0.0%',
                totalAssets: this.shouldShowValue(
                    this.singleRecordData.brand.trademarkPerTotalAssets,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.trademarkPerTotalAssets,
                          TransformationType.Percent,
                      )
                    : '0.0%',
            },
            {
                relationTrademark: 'Other intangible assets',
                enterpriseValue: this.shouldShowValue(
                    this.singleRecordData.brand.otherIntangiblesPerEV,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.otherIntangiblesPerEV,
                          TransformationType.Percent,
                      )
                    : '0.0%',
                totalAssets: this.shouldShowValue(
                    this.singleRecordData.brand.otherIntangiblesPerTotalAssets,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand
                              .otherIntangiblesPerTotalAssets,
                          TransformationType.Percent,
                      )
                    : '0.0%',
            },
            {
                relationTrademark: 'Tangible assets',
                enterpriseValue: this.shouldShowValue(
                    this.singleRecordData.brand.tangiblesPerEV,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.tangiblesPerEV,
                          TransformationType.Percent,
                      )
                    : '0.0%',
                totalAssets: this.shouldShowValue(
                    this.singleRecordData.brand.tangiblesPerTotalAssets,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.tangiblesPerTotalAssets,
                          TransformationType.Percent,
                      )
                    : '0.0%',
            },
            {
                relationTrademark: 'total',
                enterpriseValue: this.shouldShowValue(
                    this.singleRecordData.brand.sum,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.sum,
                          TransformationType.Percent,
                      )
                    : '0.0%',
                totalAssets: this.normalizeData(1, TransformationType.Percent),
            },
        ];
    }

    protected get technologyRelationData() {
        return [
            {
                relationTrademark: `Technology (${
                    this.singleRecordData.brand.technologyUsefulLife
                        ? this.singleRecordData.brand.technologyUsefulLife +
                          ' years'
                        : 'indefinite'
                })`,
                enterpriseValue: this.shouldShowValue(
                    this.singleRecordData.brand.techPerEV,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.techPerEV,
                          TransformationType.Percent,
                      )
                    : '0.0%',
                totalAssets: this.shouldShowValue(
                    this.singleRecordData.brand.techPerTotalAssets,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.techPerTotalAssets,
                          TransformationType.Percent,
                      )
                    : '0.0%',
            },
            {
                relationTrademark: 'Trademark/Brand',
                enterpriseValue: this.shouldShowValue(
                    this.singleRecordData.brand.trademarkPerEV,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.trademarkPerEV,
                          TransformationType.Percent,
                      )
                    : '0.0%',
                totalAssets: this.shouldShowValue(
                    this.singleRecordData.brand.trademarkPerTotalAssets,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.trademarkPerTotalAssets,
                          TransformationType.Percent,
                      )
                    : '0.0%',
            },
            {
                relationTrademark: 'Customer relations',
                enterpriseValue: this.shouldShowValue(
                    this.singleRecordData.brand.customerRelationPerEV,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.customerRelationPerEV,
                          TransformationType.Percent,
                      )
                    : '0.0%',
                totalAssets: this.shouldShowValue(
                    this.singleRecordData.brand.customerRelationPerTotalAssets,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand
                              .customerRelationPerTotalAssets,
                          TransformationType.Percent,
                      )
                    : '0.0%',
            },
            {
                relationTrademark: 'Software',
                enterpriseValue: this.shouldShowValue(
                    this.singleRecordData.brand.swPerEV,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.swPerEV,
                          TransformationType.Percent,
                      )
                    : '0.0%',

                totalAssets: this.shouldShowValue(
                    this.singleRecordData.brand.swPerTotalAssets,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.swPerTotalAssets,
                          TransformationType.Percent,
                      )
                    : '0.0%',
            },
            {
                relationTrademark: 'Other intangible assets',
                enterpriseValue: this.shouldShowValue(
                    this.singleRecordData.brand.otherIntangTechPerEV,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.otherIntangTechPerEV,
                          TransformationType.Percent,
                      )
                    : '0.0%',
                totalAssets: this.shouldShowValue(
                    this.singleRecordData.brand.otherIntangTechPerTotalAssets,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand
                              .otherIntangTechPerTotalAssets,
                          TransformationType.Percent,
                      )
                    : '0.0%',
            },
            {
                relationTrademark: 'Goodwill',
                enterpriseValue: this.shouldShowValue(
                    this.singleRecordData.brand.goodwillPerEV,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.goodwillPerEV,
                          TransformationType.Percent,
                      )
                    : '0.0%',
                totalAssets: this.shouldShowValue(
                    this.singleRecordData.brand.goodwillPerTotalAssets,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.goodwillPerTotalAssets,
                          TransformationType.Percent,
                      )
                    : '0.0%',
            },
            {
                relationTrademark: 'Tangible assets',
                enterpriseValue: this.shouldShowValue(
                    this.singleRecordData.brand.tangiblesPerEV,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.tangiblesPerEV,
                          TransformationType.Percent,
                      )
                    : '0.0%',
                totalAssets: this.shouldShowValue(
                    this.singleRecordData.brand.tangiblesPerTotalAssets,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.tangiblesPerTotalAssets,
                          TransformationType.Percent,
                      )
                    : '0.0%',
            },
            {
                relationTrademark: 'Total',
                enterpriseValue: this.shouldShowValue(
                    this.singleRecordData.brand.sum,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.sum,
                          TransformationType.Percent,
                      )
                    : '0.0%',
                totalAssets: this.normalizeData(1, TransformationType.Percent),
            },
        ];
    }

    protected get softwareRelationData() {
        return [
            {
                relationTrademark: `Software (${
                    this.singleRecordData.brand.softwareUsefulLife
                        ? this.singleRecordData.brand.softwareUsefulLife +
                          ' years'
                        : 'indefinite'
                })`,
                enterpriseValue: this.shouldShowValue(
                    this.singleRecordData.brand.swPerEV,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.swPerEV,
                          TransformationType.Percent,
                      )
                    : '0.0%',

                totalAssets: this.shouldShowValue(
                    this.singleRecordData.brand.swPerTotalAssets,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.swPerTotalAssets,
                          TransformationType.Percent,
                      )
                    : '0.0%',
            },
            {
                relationTrademark: 'Trademark/Brand',
                enterpriseValue: this.shouldShowValue(
                    this.singleRecordData.brand.trademarkPerEV,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.trademarkPerEV,
                          TransformationType.Percent,
                      )
                    : '0.0%',
                totalAssets: this.shouldShowValue(
                    this.singleRecordData.brand.trademarkPerTotalAssets,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.trademarkPerTotalAssets,
                          TransformationType.Percent,
                      )
                    : '0.0%',
            },
            {
                relationTrademark: 'Customer relations',
                enterpriseValue: this.shouldShowValue(
                    this.singleRecordData.brand.customerRelationPerEV,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.customerRelationPerEV,
                          TransformationType.Percent,
                      )
                    : '0.0%',
                totalAssets: this.shouldShowValue(
                    this.singleRecordData.brand.customerRelationPerTotalAssets,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand
                              .customerRelationPerTotalAssets,
                          TransformationType.Percent,
                      )
                    : '0.0%',
            },
            {
                relationTrademark: 'Technology',
                enterpriseValue: this.shouldShowValue(
                    this.singleRecordData.brand.techPerEV,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.techPerEV,
                          TransformationType.Percent,
                      )
                    : '0.0%',
                totalAssets: this.shouldShowValue(
                    this.singleRecordData.brand.techPerTotalAssets,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.techPerTotalAssets,
                          TransformationType.Percent,
                      )
                    : '0.0%',
            },
            {
                relationTrademark: 'Other intangible assets',
                enterpriseValue: this.shouldShowValue(
                    this.singleRecordData.brand.otherIntangTechPerEV,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.otherIntangTechPerEV,
                          TransformationType.Percent,
                      )
                    : '0.0%',
                totalAssets: this.shouldShowValue(
                    this.singleRecordData.brand.otherIntangTechPerTotalAssets,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand
                              .otherIntangTechPerTotalAssets,
                          TransformationType.Percent,
                      )
                    : '0.0%',
            },
            {
                relationTrademark: 'Goodwill',
                enterpriseValue: this.shouldShowValue(
                    this.singleRecordData.brand.goodwillPerEV,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.goodwillPerEV,
                          TransformationType.Percent,
                      )
                    : '0.0%',
                totalAssets: this.shouldShowValue(
                    this.singleRecordData.brand.goodwillPerTotalAssets,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.goodwillPerTotalAssets,
                          TransformationType.Percent,
                      )
                    : '0.0%',
            },
            {
                relationTrademark: 'Tangible assets',
                enterpriseValue: this.shouldShowValue(
                    this.singleRecordData.brand.tangiblesPerEV,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.tangiblesPerEV,
                          TransformationType.Percent,
                      )
                    : '0.0%',
                totalAssets: this.shouldShowValue(
                    this.singleRecordData.brand.tangiblesPerTotalAssets,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.tangiblesPerTotalAssets,
                          TransformationType.Percent,
                      )
                    : '0.0%',
            },
            {
                relationTrademark: 'Total',
                enterpriseValue: this.shouldShowValue(
                    this.singleRecordData.brand.sum,
                )
                    ? this.normalizeData(
                          this.singleRecordData.brand.sum,
                          TransformationType.Percent,
                      )
                    : '0.0%',
                totalAssets: this.normalizeData(1, TransformationType.Percent),
            },
        ];
    }

    protected get targetMultiple() {
        const currentSum = Number(this.singleRecordData.brand.sum) * 100;
        if (currentSum > 1000) {
            return 200;
        } else if (currentSum > 500) {
            return 100;
        } else if (currentSum > 200) {
            return 50;
        } else {
            return 25;
        }
    }

    protected get calculateMaxYValue() {
        // get the smallest next multiple of 25 (default target multiple) above current sum
        const currentSum = Number(this.singleRecordData.brand.sum) * 100;
        return (
            (Math.floor(currentSum / this.targetMultiple) + 1) *
            this.targetMultiple
        );
    }

    protected get dataSource() {
        if (!this.singleRecordData || !this.singleRecordData.brand.sum) {
            return null;
        }
        const dataObject: ChartDataInterface = {
            chart: {
                numbersuffix: ' %',
                plottooltext: '<strong>$seriesName: $value%</strong>',
                theme: 'fusion',
                showYAxisLine: true,
                yAxisLineColor: '#f2f2f2',
                yaxismaxvalue: this.calculateMaxYValue,
                adjustDiv: '0',
                numDivLines: this.calculateMaxYValue / this.targetMultiple - 1,
                showLegend: false,
                labelFontColor: '#354052',
                toolTipBgColor: '#333f52',
                toolTipBorderColor: '#333f52',
                toolTipColor: '#ffffff',
                baseFont: "'IBM Plex Sans-SemiBold', sans-serif",
                valueFont: "'IBM Plex Sans-Bold', sans-serif",
                valueFontBold: true,
                valueFontColor: '#ffffff',
                valueBgColor: '#666',
                valueBgAlpha: '60',
                plotSpacePercent: '30',
                valueFontSize: 12,
                hoverAlpha: '100',
                caption: 'Asset structure',
                captionAlignment: 'center',
                captionFontSize: '12',
            },
            categories: [
                {
                    category: [
                        {
                            label: 'assets',
                        },
                        {
                            label: 'finance',
                        },
                    ],
                },
            ],
            dataset: [],
        };

        let datasetArray = [
            {
                label: 'trademark',
                value: this.singleRecordData.brand.trademarkPerEV,
                color: '#44355b',
                index: 0,
            },
            {
                label: 'other intangibles',
                value: this.singleRecordData.brand.otherIntangiblesPerEV,
                color: '#894b70',
                index: 0,
            },
            {
                label: 'goodwill',
                value: this.singleRecordData.brand.goodwillPerEV,
                color: '#a95872',
                index: 0,
            },
            {
                label: 'tangible assets',
                value: this.singleRecordData.brand.tangiblesPerEV,
                color: '#c66871',
                index: 0,
            },
            {
                label: 'enterprise value',
                value: '1',
                color: '#f7b267',
                index: 1,
            },
            {
                label: 'non-interest liabilities',
                value: (
                    parseFloat(
                        this.singleRecordData.brand.sum.replace(',', '.'),
                    ) - 1
                ).toString(),
                color: '#ee9669',
                index: 1,
            },
        ];

        if (this.isTrademark) {
            datasetArray.splice(1, 0, {
                label: 'customer relations',
                value: this.singleRecordData.brand.customerRelationPerEV,
                color: '#664068',
                index: 0,
            });
        } else {
            datasetArray.unshift({
                label: 'customer relations',
                value: this.singleRecordData.brand.customerRelationPerEV,
                color: '#664068',
                index: 0,
            });
        }

        if (this.isGoodwill) {
            datasetArray = [
                {
                    label: 'goodwill',
                    value: this.singleRecordData.brand.goodwillPerEV,
                    color: '#44355b',
                    index: 0,
                },
                {
                    label: 'customer relations',
                    value: this.singleRecordData.brand.customerRelationPerEV,
                    color: '#664068',
                    index: 0,
                },
                {
                    label: 'trademark',
                    value: this.singleRecordData.brand.trademarkPerEV,
                    color: '#894b70',
                    index: 0,
                },
                {
                    label: 'other intangibles',
                    value: this.singleRecordData.brand.otherIntangiblesPerEV,
                    color: '#a95872',
                    index: 0,
                },
                {
                    label: 'tangible assets',
                    value: this.singleRecordData.brand.tangiblesPerEV,
                    color: '#c66871',
                    index: 0,
                },
                {
                    label: 'enterprise value',
                    value: '1',
                    color: '#f7b267',
                    index: 1,
                },
                {
                    label: 'non-interest liabilities',
                    value: (
                        parseFloat(
                            this.singleRecordData.brand.sum.replace(',', '.'),
                        ) - 1
                    ).toString(),
                    color: '#ee9669',
                    index: 1,
                },
            ];
        }

        if (this.isTechnology) {
            datasetArray = [
                {
                    label: 'technology',
                    value: this.singleRecordData.brand.techPerEV,
                    color: '#de7d6d',
                    index: 0,
                },
                {
                    label: 'trademark',
                    value: this.singleRecordData.brand.trademarkPerEV,
                    color: '#44355b',
                    index: 0,
                },
                {
                    label: 'customer relations',
                    value: this.singleRecordData.brand.customerRelationPerEV,
                    color: '#664068',
                    index: 0,
                },
                {
                    label: 'software',
                    value: this.singleRecordData.brand.swPerEV,
                    color: '#732673',
                    index: 0,
                },
                {
                    label: 'other intangibles',
                    value: this.singleRecordData.brand.otherIntangTechPerEV,
                    color: '#894b70',
                    index: 0,
                },
                {
                    label: 'goodwill',
                    value: this.singleRecordData.brand.goodwillPerEV,
                    color: '#a95872',
                    index: 0,
                },
                {
                    label: 'tangible assets',
                    value: this.singleRecordData.brand.tangiblesPerEV,
                    color: '#c66871',
                    index: 0,
                },
                {
                    label: 'enterprise value',
                    value: '1',
                    color: '#f7b267',
                    index: 1,
                },
                {
                    label: 'non-interest liabilities',
                    value: (
                        parseFloat(
                            this.singleRecordData.brand.sum.replace(',', '.'),
                        ) - 1
                    ).toString(),
                    color: '#ee9669',
                    index: 1,
                },
            ];
        }

        if (this.isSoftware) {
            datasetArray = [
                {
                    label: 'software',
                    value: this.singleRecordData.brand.swPerEV,
                    color: '#732673',
                    index: 0,
                },
                {
                    label: 'trademark',
                    value: this.singleRecordData.brand.trademarkPerEV,
                    color: '#44355b',
                    index: 0,
                },
                {
                    label: 'customer relations',
                    value: this.singleRecordData.brand.customerRelationPerEV,
                    color: '#664068',
                    index: 0,
                },
                {
                    label: 'technology',
                    value: this.singleRecordData.brand.techPerEV,
                    color: '#de7d6d',
                    index: 0,
                },
                {
                    label: 'other intangibles',
                    value: this.singleRecordData.brand.otherIntangTechPerEV,
                    color: '#894b70',
                    index: 0,
                },
                {
                    label: 'goodwill',
                    value: this.singleRecordData.brand.goodwillPerEV,
                    color: '#a95872',
                    index: 0,
                },
                {
                    label: 'tangible assets',
                    value: this.singleRecordData.brand.tangiblesPerEV,
                    color: '#c66871',
                    index: 0,
                },
                {
                    label: 'enterprise value',
                    value: '1',
                    color: '#f7b267',
                    index: 1,
                },
                {
                    label: 'non-interest liabilities',
                    value: (
                        parseFloat(
                            this.singleRecordData.brand.sum.replace(',', '.'),
                        ) - 1
                    ).toString(),
                    color: '#ee9669',
                    index: 1,
                },
            ];
        }

        dataObject.dataset = datasetArray
            .filter((item) => {
                if (item.value && parseFloat(item.value) * 100 >= 0.1) {
                    const numValue = parseFloat(item.value.replace(',', '.'));
                    if (numValue) {
                        return item.value;
                    }
                }
            })
            .map((item) => {
                // @ts-ignore
                const value = (parseFloat(item.value.replace(',', '.')) * 100).toFixed(1);
                const assetData = new Array(2).fill({ value: '' });
                assetData[item.index] = {
                    value,
                    displayValue: item.label + ': ' + value + '%',
                };
                return {
                    seriesname: item.label,
                    color: item.color,
                    showValues: true,
                    data: assetData,
                };
            });
        return dataObject;
    }

    protected normalizeData(
        value: string | number | null,
        transformationType?: TransformationType,
    ) {
        if (!value) {
            return '-';
        }
        if (!transformationType) {
            const formattedData =
                typeof value === 'number'
                    ? value
                    : parseFloat(value.replace(',', '.'));
            if (!isNaN(formattedData)) {
                if (formattedData.toFixed(3) === '0.000') {
                    return 0;
                }
                if (formattedData < 1) {
                    if (formattedData.toString().length > 5) {
                        return formattedData
                            .toFixed(3)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                    } else {
                        return formattedData
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                    }
                }
                return formattedData
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            }
            return value;
        }
        if (transformationType === TransformationType.Round) {
            const formattedNumber =
                typeof value === 'number'
                    ? value
                    : parseFloat(value.replace(',', '.'));
            return Math.round(formattedNumber);
        }
        if (transformationType === TransformationType.Multiplier) {
            const formattedNumber =
                typeof value === 'number'
                    ? value
                    : parseFloat(value.replace(',', '.'));
            return formattedNumber.toFixed(2) + 'x';
        }
        if (transformationType === TransformationType.Percent) {
            const formattedNumber =
                typeof value === 'number'
                    ? value
                    : parseFloat(value.replace(',', '.'));
            return (formattedNumber * 100).toFixed(1) + '%';
        }
    }

    protected shouldShowValue(value: string | number | null) {
        if (!value) {
            return false;
        }
        const formattedData =
            typeof value === 'number'
                ? value
                : parseFloat(value.replace(',', '.'));
        if (!isNaN(formattedData) && Number(formattedData.toFixed(3)) > 0) {
            return true;
        }
        return false;
    }

    protected formatDate(date: string) {
        return formatDateWithMonthName(date);
    }

    protected navigateToSingleFolder() {
        if (this.sampleRecord) {
            this.$router.push({ name: 'Help' });
            return;
        }
        this.$router.push({ name: 'SingleFolder' });
    }

    protected async onDownload() {
        this.isButtonEnabled = false;
        this.$message.info('Generating report, please wait.');
        const blob = await this.decodePDF(Number(this.singleRecordData.id));
        let name = '';
        if (this.singleRecordData.prodGroup === 't') {
            name =
                `Markables_Record_${this.singleRecordData.brand.importId}_tm_` +
                `${this.singleRecordData.brand.brandBusinessComb.replace(
                    /[,. ]+/g,
                    '_',
                )}.pdf`;
        } else if (this.singleRecordData.prodGroup === 'c') {
            name =
                `Markables_Record_${this.singleRecordData.brand.importId}_cr_` +
                `${this.singleRecordData.brand.brandBusinessComb.replace(
                    /[,. ]+/g,
                    '_',
                )}.pdf`;
        } else if (this.singleRecordData.prodGroup === 'g') {
            name =
                `Markables_Record_${this.singleRecordData.brand.importId}_gw_` +
                `${this.singleRecordData.brand.brandBusinessComb.replace(
                    /[,. ]+/g,
                    '_',
                )}.pdf`;
        } else if (this.singleRecordData.prodGroup === 'e') {
            name =
                `Markables_Record_${this.singleRecordData.brand.importId}_tc_` +
                `${this.singleRecordData.brand.brandBusinessComb.replace(
                    /[,. ]+/g,
                    '_',
                )}.pdf`;
        } else {
            name =
                `Markables_Record_${this.singleRecordData.brand.importId}_sw_` +
                `${this.singleRecordData.brand.brandBusinessComb.replace(
                    /[,. ]+/g,
                    '_',
                )}.pdf`;
        }
        this.fileSaver(blob, name);
        this.isButtonEnabled = true;
    }

    protected async decodePDF(id: number) {
        const projectName = this.singleRecordData.projects[0].name;
        const invoice = await this.downloadBrand({
            id,
            projectName,
        });
        const byteCharacters = atob(invoice);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: 'application/pdf' });
    }

    protected fileSaver(blob: Blob, name: string) {
        const data = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        const nav = window.navigator as any;
        if (nav.msSaveOrOpenBlob) {
            nav.msSaveOrOpenBlob(blob, name);
            return;
        } else if (nav.msSaveBlob) {
            nav.msSaveBlob(blob, name);
            return;
        }
        link.href = data;
        link.download = name;
        document.body.appendChild(link);
        link.click();
    }
}
